import { lazy } from 'react';

export default [
    {
        path: '/city',
        exact: true,
        component: lazy(() => import(/* webpackChunkName: 'CityLayout' */ './layout')),
    },
];
